export default __webpack_public_path__ + "341c7475f14369b4cb1ec9896c74e674.png";